/**
 login-view
 Created by RuSsCiTy on 07.05.2018
 **/

import Backbone from "backbone";
import { PAGES } from "../../../const/constants";
import { mainChannel, viewChannel } from "../../../init/message-hub";
import { isAtLeatOneCookiesOfListAccepted } from "../../../utils/cookie-config-helper";

const template = require("./template.pug");
require("./style.scss");

export default Backbone.View.extend({
  className: "introContainer",

  events: {
    "click .overview-link": "gotoOverview",
    "click .cancel-link": "cancel",
    "click .accept-all-cookie-btn": "acceptAllCookies",
    "click .accept-minimal-cookie-btn": "acceptMinimalCookies",
    "click .toggle-cookie": "toggleCookie"
  },

  initialize(container) {
    this.render(container);
    this.initElements();
  },

  render() {
    this.$el.html(template);
  },

  gotoOverview(e) {
    e.preventDefault();
    e.stopPropagation();
    viewChannel.request("showPage", PAGES.details);
  },

  acceptAllCookies() {
    mainChannel.request("acceptAllCookies");
    viewChannel.request("togglePreferenceButton", true);
  },

  acceptMinimalCookies() {
    mainChannel.request("acceptMinimalCookies");
    viewChannel.request("togglePreferenceButton", true);
  },

  initElements() {
    this.$overViewLink = this.$(".overview-link");
    this.$acceptMinimalBtn = this.$(".accept-minimal-cookie-btn");
    this.$cancelBtn = this.$(".cancel-link");
  },

  reset() {
    this.checkIfAlreadyAccepted();
    this.delegateEvents();
  },

  checkIfAlreadyAccepted() {
    if (!mainChannel.request("isSomeCookieAccepted")) {
      this.$overViewLink.show();
      this.$acceptMinimalBtn.hide();
      this.$cancelBtn.show();
    } else {
      this.$overViewLink.show();
      this.$acceptMinimalBtn.show();
      this.$cancelBtn.hide();
    }
  },

  cancel(){
    viewChannel.request("hide");
    viewChannel.request("togglePreferenceButton", true);
  }
});



// WEBPACK FOOTER //
// ./src-cookie-manager/views/pages/intro/intro.js